import { render, staticRenderFns } from "./ChatQuickReply.vue?vue&type=template&id=374a3482&scoped=true"
import script from "./ChatQuickReply.vue?vue&type=script&lang=js"
export * from "./ChatQuickReply.vue?vue&type=script&lang=js"
import style0 from "./ChatQuickReply.vue?vue&type=style&index=0&id=374a3482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a3482",
  null
  
)

export default component.exports